import { has } from 'ramda';
export function isPlainObject(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}
export function isFormNavigationState(value) {
    return !!value && typeof value === 'object' && has('action')(value) && (value.action === 'navigate' || value.action === 'cancel' || value.action === 'save');
}
